import { Row, Col, Button, Table, Alert, Nav } from "react-bootstrap";
import useSWR from "swr";
import AuthenticatedWrapper from "../../../components/wrapper";
import { fetcher, serverUrl, swrConfig } from "../../../helpers/utility";
import { useNavigate } from "react-router-dom";
import variables from "../../../styles/utils.module.scss";
import styles from "../../../styles/provider.module.scss";
import { useCallback, useState } from "react";
import axios from "axios";
import { APPROVED, IN_REVIEW } from "../../../helpers/constants";
import Loading from "../../../components/loading";
import InputWithLabel from "../../../components/inputWithLabel";
import { useForm } from "react-hook-form";
import TabWithFilter from "../../../components/TabWithFilter";
import DashboardLayout from './DashboardLayout';
import LocationsContent from '../../../components/LocationsContent';

function ProviderDashboard({ user }) {
  const steps = { ACTIVE: "ACTIVE", IN_REVIEW: "IN_REVIEW" };
  const [step, setStep] = useState(steps.ACTIVE);
  const navigate = useNavigate();
  const { register, watch } = useForm();
  const formValues = watch();
  const {
    data: ownLocationData,
    error: locationError,
    isLoading: locationIsLoading,
  } = useSWR(`${serverUrl}/location/own`, fetcher, swrConfig);

  const activeLocations = useCallback(() => {
    if (ownLocationData && ownLocationData.locations?.length > 0) {
      let approvedLocations = ownLocationData.locations?.filter((location) => {
        return (
          location.status === APPROVED &&
          (!formValues?.locationName ||
            location?.name?.toLowerCase().includes(formValues?.locationName?.toLowerCase()) ||
            formValues?.locationName?.length < 3)
        );
      });

      return approvedLocations;
    }
  }, [ownLocationData, formValues?.locationName]);

  const pendingLocations = useCallback(() => {
    if (ownLocationData && ownLocationData.locations?.length > 0) {
      let unapprovedLocations = ownLocationData.locations?.filter((location) => {
        return (
          location.status === IN_REVIEW &&
          (!formValues?.locationName ||
            location?.name?.toLowerCase().includes(formValues?.locationName?.toLowerCase()) ||
            formValues?.locationName?.length < 3)
        );
      });

      return unapprovedLocations;
    } else {
      return [];
    }
  }, [ownLocationData, formValues?.locationName]);

  const goToLocation = useCallback(
    ({ locationId }) => {
      navigate(`/add-location?locationId=${locationId}`);
    },
    [navigate]
  );

  const goToLocationSubscription = useCallback(
    ({ locationId }) => {
      navigate(`/add-location?locationId=${locationId}&initialStep=PAYMENT`);
    },
    [navigate]
  );

  const goToPlacementDetails = useCallback(
    ({ locationId }) => {
      navigate(`/location?locationId=${locationId}`);
    },
    [navigate]
  );

  return (
      <DashboardLayout user={user}>
        <div style={{ marginTop: "15px", padding: "0px 0px" }}>
          <Row style={{ marginTop: 15 }}>
            <Col lg={10}>
              <LocationsContent summaryOnly={true} />
            </Col>

            {/* <Col lg={5} className="mobile-gap"> */}
              {/*  <Row style={{ marginTop: 15 }}>
                <Col lg={12}>
                  <Alert key={"organisation-not-approved"} variant={`info`}>
                    Welcome to bPlaced. A member of our team will now review your organisation
                    details. Please continue to add each of your locationsContent in the meantime.
                  </Alert>
                </Col>
              </Row> */}

              {/* <Row style={{ marginTop: 0 }}>
                <Col xs={12}>
                  <h1 className="h3">Insights</h1>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <div className={styles.statBox}>
                      <div className={styles.statBoxNumber}>47</div>
                      <div className={styles.statBoxLabel}>Searches this month</div>
                    </div>

                    <div className={styles.statBox}>
                      <div className={styles.statBoxNumber}>3</div>
                      <div className={styles.statBoxLabel}>Enquiries this month</div>
                    </div>

                    <div className={styles.statBox}>
                      <div className={styles.statBoxNumber}>87%</div>
                      <div className={styles.statBoxLabel}>Average capacity</div>
                    </div>
                  </div>
                </Col>
              </Row> */}

              {/* <Row style={{ marginTop: 45 }}>
                <Col xs={12}>
                  <h1 className="h3">Manage Team</h1>
                  <div style={{ marginTop: 10, marginBottom: 15 }}>
                    <Button
                      onClick={() => {
                        navigate("/add-user");
                      }}
                      variant="outline-primary"
                    >
                      NEW USER
                    </Button>
                  </div>
                </Col>
              </Row> */}
            {/* </Col> */}
          </Row>
        </div>
      </DashboardLayout>
  );
}

export default ProviderDashboard;
